var map = {
	"./ada-hegerberg.png": "9082",
	"./alex-morgan.png": "58c8",
	"./amandine-henry.png": "c4e6",
	"./andres-iniesta.png": "af9d",
	"./carli-lloyd.png": "3ab2",
	"./christine-sinclair.png": "6eea",
	"./cristiano-ronaldo.png": "9e6f",
	"./eden-hazard.png": "2b95",
	"./gareth-bale.png": "6085",
	"./julie-ertz.png": "711a",
	"./kylian-mbappe.png": "026a",
	"./lionel-messi.png": "5329",
	"./marta.png": "51bb",
	"./megan-rapinoe.png": "e1ca",
	"./mohamed-salah.png": "dc99",
	"./neymar-jr.png": "e181",
	"./paul-pogba.png": "1fa1",
	"./robert-lewandowski.png": "9b53",
	"./sam-kerr.png": "b56c",
	"./unknown.png": "0b6b",
	"./wendie-renard.png": "bfeb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "634c";